import { Controller } from "@hotwired/stimulus"
import { trackYouLeadProduct } from "../partials/client/analytics/track-event"

export default class extends Controller {
  static targets = ["product"]

  connect() {
    const scrollUpCallback = this.getScrollUpCallback()
    window.addEventListener("scroll", scrollUpCallback, false)

    this.productTargets.forEach((product) => {
      this.onVisible(product, this.sendEventToYouleed)
    })
  }

  onVisible(element, callback) {
    new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0) {
            if (
              this.ignoreYouLeadUntilId() ||
              window.skipYouLeadUntilId === element.id
            ) {
              callback(element)
              observer.disconnect()
              this.clearYouLeadUntilId()
            } else {
              // ignore
            }
          }
        })
      },
      { rootMargin: "-20%" },
    ).observe(element)
  }

  sendEventToYouleed(product) {
    trackYouLeadProduct([product.dataset.youleedId])
  }

  ignoreYouLeadUntilId() {
    return !this.isYouLeadUntilIdInProductTargetsIds()
  }

  isYouLeadUntilIdInProductTargetsIds() {
    return this.productTargets
      .map((product) => product.id)
      .includes(window.skipYouLeadUntilId)
  }

  clearYouLeadUntilId() {
    if (this.isYouLeadUntilIdInProductTargetsIds()) {
      window.skipYouLeadUntilId = null
    }
  }

  detectScrollUpUntilEndOfAutoScroll(event) {
    if (!window.skipYouLeadUntilId) {
      return
    }

    const lastScrollTop = window.lastScrollTop || 0
    const st = window.scrollY || document.documentElement.scrollTop
    if (st < lastScrollTop) {
      // upscroll
      this.clearYouLeadUntilId()
    }
    window.lastScrollTop = st <= 0 ? 0 : st
  }

  getScrollUpCallback() {
    return this.detectScrollUpUntilEndOfAutoScroll.bind(this)
  }
}
